<template>
  <v-layout>
    <app-loader title="Загрузка данных Поставки" :loading="!pageLoaded" />
    <v-layout v-if="printMode">
      <PrintForm
        :state="currentState"
        :active-tab="activeTab"
        class="invisible-block print"
        @close="openPrintForm"
      />
    </v-layout>

    <v-layout v-show="pageLoaded" wrap class="no-print">
      <v-flex :class="`${blockWidth ? 'xs6' : 'xs5'}`">
        <v-card
          v-show="!compactMode"
          class="mt-0 mr-1 mb-1 ml-0 pa-2"
          :style="{ height: blockHeight + 'px' }"
        >
          <!-- INFO -->
          <v-layout align-center>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                small
                icon
                class="ma-0"
                @click="$router.go(-1)"
              >
                <v-icon color="grey darken-1"> arrow_back </v-icon>
              </v-btn>
              <span>Назад</span>
            </v-tooltip>
            <h2 class="px-2 subheading font-weight-bold title-style">
              {{ "Поставка № " + title }}
            </h2>
            <v-spacer />
            <span class="handleByAdminCheckbox">
              <v-tooltip bottom>
                <template slot="activator"
                  ><v-checkbox
                    v-model="isHandledByAdmin"
                    :disabled="isHandledByAdmin"
                    @change="markAsHandled"
                /></template>

                Отметить как обработана
              </v-tooltip>
            </span>
            <v-btn
              v-if="
                (currentState &&
                  currentState.id === eShippingStates.NotAccepted) ||
                (currentState &&
                  currentState.id === eShippingStates.CanceledByClient)
              "
              slot="activator"
              small
              color="primary"
              dark
              class="my-0 ml-0 mr-1"
              style="width: 120px"
              :loading="changeStateProccessedByServer"
              @click="restore"
            >
              Возобновить
            </v-btn>
            <v-menu
              menu-props="offsetY"
              :close-on-content-click="phases.length > 0 ? false : true"
              :disabled="!canEdit"
            >
              <v-btn
                slot="activator"
                small
                :color="canEdit ? 'primary' : 'grey'"
                dark
                :loading="changeStateProccessedByServer"
                class="ma-0"
                style="width: 120px"
              >
                <span class="title-style pl-2">{{
                  currentState ? currentState.title : "Не определен"
                }}</span>
                <v-icon right small class="ml-0 pr-1">
                  keyboard_arrow_down
                </v-icon>
              </v-btn>
              <v-list>
                <template v-for="s in availableStates">
                  <v-list-tile :key="s.id">
                    <v-list-tile-title
                      v-if="phases.length > 0"
                      class="clickable-row"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span class="grey--text text--darken-2" v-on="on">
                            {{ s.title }}
                          </span>
                        </template>
                        <span>Для установки статуса - удалите звенья</span>
                      </v-tooltip>
                    </v-list-tile-title>
                    <v-list-tile-title
                      v-else
                      class="clickable-row"
                      @click="changeState(s.id)"
                    >
                      {{ s.title }}
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
            <app-states-history />
            <VersionSwitcher
              v-model="currentVersion"
              :items="versions"
              :disabled="disabled"
            />
            <RelationsMap v-if="!allowVisible" :id="id" resource="shippings" />
            <v-tooltip bottom>
              <template v-if="!allowVisible" slot="activator">
                <app-same-region-shippings :id="id" />
              </template>
              <span>Поставки из того же региона</span>
            </v-tooltip>
          </v-layout>
          <v-layout
            column
            class="ma-1 pa-1"
            :style="{ height: blockInfoHeight + 'px', 'overflow-y': 'auto' }"
          >
            <app-info :items="info">
              <template v-if="!allowVisible" slot="goods-details">
                <app-goods-details :id="id" />
              </template>
              <template slot="goods-summary">
                <GoodsSummary :id="id" :allow-visible="allowVisible" />
              </template>
              <template slot="categories-info">
                <CategoriesInfo :id="id" />
              </template>
            </app-info>
          </v-layout>
          <!-- ACTIONS  -->
          <v-layout justify-center>
            <v-flex style="position: absolute; bottom: 4px">
              <app-derivative-shippings
                v-if="!allowVisible"
                :id="id"
                :splitted="isSplited"
                :disabled="!canEdit"
              />

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  small
                  icon
                  class="my-0"
                  @click="openPrintForm(true)"
                >
                  <v-icon>print</v-icon>
                </v-btn>
                <span>Печать</span>
              </v-tooltip>

              <app-shipping-output-form :id="id" :number="title" />

              <v-tooltip top>
                <v-btn
                  v-if="!allowVisible"
                  slot="activator"
                  small
                  :disabled="
                    isAllowEditPhase
                      ? !isAllowEditPhase
                      : !canEdit || isPhasesInRoute
                  "
                  icon
                  class="my-0"
                  @click="showEditor"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>{{
                  isPhasesInRoute
                    ? "Звено добавлено в маршрут, инфо по поставке редактировать запрещено"
                    : "Редактировать"
                }}</span>
              </v-tooltip>
              <v-dialog
                v-if="editorDialog"
                v-model="editorDialog"
                persistent
                width="1280"
                style="overflow-y: hidden"
              >
                <app-editor
                  :id="id"
                  @cancel="closeEditor"
                  @save="handleShipmentRequestChange"
                />
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex :class="`${blockWidth ? 'xs6' : 'xs4'}`">
        <v-layout column>
          <v-card
            v-if="!allowVisible"
            v-show="!compactMode"
            class="mt-0 mx-1 mb-1 pa-2"
            :style="{ height: blockActionsHeight + 'px' }"
          >
            <v-tabs
              :show-arrows="true"
              next-icon="keyboard_arrow_right"
              prev-icon="keyboard_arrow_left"
              @change="changeActiveTab"
            >
              <v-tab style="text-transform: none">
                <h2 class="subheading font-weight-bold">
                  Сообщения
                  <span
                    v-if="unreadMessages.length > 0"
                    class="blue--text text--darken-4"
                    >{{ unreadMessages.length }}</span
                  >
                </h2>
              </v-tab>
              <v-tab style="text-transform: none">
                <h2 class="subheading font-weight-bold">
                  Заметки
                  <span
                    v-if="notes.length > 0"
                    class="blue--text text--darken-4"
                    >{{ notes.length }}</span
                  >
                </h2>
              </v-tab>
              <v-tab style="text-transform: none">
                <h2 class="subheading font-weight-bold">
                  Документы
                  <span
                    v-if="attachments.length || attachmentsForExport.length"
                    class="blue--text text--darken-4"
                    >{{
                      attachments.length + attachmentsForExport.length
                    }}</span
                  >
                </h2>
              </v-tab>
              <v-tab style="text-transform: none">
                <h2 class="subheading font-weight-bold">
                  Фото
                  <span
                    v-if="images.length > 0"
                    class="blue--text text--darken-4"
                    >{{ images.length }}</span
                  >
                </h2>
              </v-tab>
              <!--Messages-->
              <v-tab-item>
                <app-messages :id="id" :disabled="!canEdit" :user="user" />
              </v-tab-item>
              <!-- NOTES -->
              <v-tab-item>
                <app-notes :id="id" :disabled="!canEdit" />
              </v-tab-item>
              <!-- ATTACHMENTS -->
              <v-tab-item>
                <div
                  :style="{
                    height: blockActionsHeight - 50 + 'px',
                  }"
                >
                  <Attachments
                    :value="attachmentsForExport"
                    :block-height="(blockActionsHeight - 150) / 2"
                    :resource="`shippings/${id}`"
                    :disabled="!canEdit || !user.hasEmployee"
                    :disabled-sender="false"
                    :disabled-upload="!user.hasEmployee"
                    :disabled-upload-to-server="!user.hasEmployee"
                    :disabled-download="!user.hasEmployee"
                    :type="attachmentsType.EXPORT"
                    :need-confirm="needConfirmForAttachments.need"
                    :need-confirm-text="needConfirmForAttachments.text"
                    title="Экспортные документы"
                    :has-visibility-switch="isClientManagerRole"
                    :on-change-file-visibility="
                      handleOnChangeExportFileVisibility
                    "
                    @change="openLabelDialog"
                    @input="changeAttachmentsForExport"
                  />
                  <v-divider class="mt-2" />
                  <Attachments
                    :value="attachments"
                    :block-height="(blockActionsHeight - 150) / 2"
                    :resource="`shippings/${id}`"
                    :disabled="!canEdit"
                    :disabled-sender="false"
                    :disabled-upload="!user.hasEmployee"
                    :disabled-upload-to-server="!user.hasEmployee"
                    :disabled-download="!user.hasEmployee"
                    title="Другие документы"
                    :has-visibility-switch="isClientManagerRole"
                    :is-visibility-switch-disabled="true"
                    @input="changeAttachments"
                  />
                </div>
              </v-tab-item>

              <v-tab-item>
                <ImagesList
                  :id="id"
                  :block-height="blockActionsHeight - 90"
                  :is-left="true"
                  :disabled="!canEdit"
                  resource="shippings"
                  @change="getImages"
                />
              </v-tab-item>
            </v-tabs>
          </v-card>
          <v-layout v-else>
            <v-flex>
              <v-card
                class="mt-0 mx-1 mb-1 pa-2"
                :style="{ height: blockActionsHeight + 'px' }"
              >
                <v-tabs
                  :show-arrows="true"
                  next-icon="keyboard_arrow_right"
                  prev-icon="keyboard_arrow_left"
                  @change="changeActiveTab"
                >
                  <v-tab style="text-transform: none">
                    <h2 class="subheading font-weight-bold">Сообщения</h2>
                  </v-tab>
                  <v-tab style="text-transform: none">
                    <h2 class="subheading font-weight-bold">
                      Документы
                      <span
                        v-if="attachments.length || attachmentsForExport.length"
                        class="blue--text text--darken-4"
                        >{{
                          attachments.length + attachmentsForExport.length
                        }}</span
                      >
                    </h2>
                  </v-tab>
                  <!--Messages-->
                  <v-tab-item>
                    <app-messages :id="id" :disabled="!canEdit" />
                  </v-tab-item>
                  <!-- ATTACHMENTS -->
                  <v-tab-item>
                    <div
                      :style="{
                        height: blockActionsHeight - 50 + 'px',
                      }"
                    >
                      <Attachments
                        v-model="attachmentsForExport"
                        :block-height="(blockActionsHeight - 190) / 2"
                        :resource="`shippings/${id}`"
                        :disabled="!canEdit || !user.hasEmployee"
                        :disabled-sender="false"
                        :disabled-upload="!user.hasEmployee"
                        :disabled-upload-to-server="!user.hasEmployee"
                        :disabled-download="!user.hasEmployee"
                        :type="attachmentsType.EXPORT"
                        title="Экспортные документы"
                        @change="openLabelDialog"
                        @input="changeAttachmentsForExport"
                      />
                      <v-divider class="my-2" />
                      <Attachments
                        v-model="attachments"
                        :block-height="(blockActionsHeight - 120) / 2"
                        :resource="`shippings/${id}`"
                        :disabled="!canEdit"
                        :disabled-sender="false"
                        :disabled-upload="!user.hasEmployee"
                        :disabled-upload-to-server="!user.hasEmployee"
                        :disabled-download="!user.hasEmployee"
                        title="Другие документы"
                        @input="changeAttachments"
                      />
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-flex>
          </v-layout>
          <!-- Dates -->
          <v-card class="mt-1 mb-0 mx-1">
            <DatesTable
              v-show="!compactMode"
              :id="id"
              :can-edit="canEdit"
              table-height="176"
              :disabled="disabled"
            />
          </v-card>
        </v-layout>
      </v-flex>

      <v-flex v-if="!allowVisible" xs3>
        <!-- LABLES -->
        <v-card v-show="!compactMode" class="mt-0 mr-0 mb-1 ml-1 pa-2">
          <app-lables
            :id="id"
            :values="labels"
            :can-edit="canEdit"
            :block-height="blockHeight"
            @change="updateLabel"
          />
        </v-card>
      </v-flex>

      <!-- PHASES -->
      <v-flex v-if="!allowVisible" xs-12>
        <ShippingDelivery
          :id="id"
          :can-edit="canEdit"
          :user="user"
          @compactModeChange="phasesFullScreen = !phasesFullScreen"
        />
      </v-flex>
    </v-layout>
    <v-dialog v-model="labelDialog" persistent width="335">
      <v-card>
        <v-card-title>
          <h2>Изменение меток в Поставке</h2>
        </v-card-title>
        <v-card-text>
          <h3>Отметить, что:</h3>
          <v-list>
            <v-list-tile v-if="!invoiceInSystem || labelDialogDeleteMode">
              <v-list-tile-content
                @click="labelDialogInvoice = !labelDialogInvoice"
              >
                <v-list-tile-title>Invoice в системе</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox v-model="labelDialogInvoice" />
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-if="!exInSystem || labelDialogDeleteMode">
              <v-list-tile-content @click="labelDialogEx = !labelDialogEx">
                <v-list-tile-title>Ex в системе</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-checkbox v-model="labelDialogEx" />
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            flat
            color="primary"
            :loading="labelsLoading"
            :disabled="
              !labelDialogDeleteMode && !labelDialogInvoice && !labelDialogEx
            "
            @click="changeLabel"
          >
            Ок
          </v-btn>
          <v-spacer />
          <v-btn small flat color="primary" @click="closeLabelDialog">
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <app-action-confirm
      :value="showActionDialog"
      text="Вы действительно хотите покинуть Поставку? Данные не синхронизированы с ERP"
      @cancel="closeActionDialog"
      @confirm="confirmActionDialog"
    />
  </v-layout>
</template>

<script>
import Info from "../../components/Info.vue";
import Notes from "./components/attachments/Notes.vue";
import Messages from "./components/attachments/Messages.vue";
import Editor from "./components/shipping-editor/Editor.vue";
import VersionSwitcher from "../../components/VersionSwitcher.vue";
import StatesHistory from "./components/info/StatesHistory.vue";
import Lables from "./components/labels/Lables.vue";
import ShippingOutputForm from "./components/info/ShippingOutputForm.vue";
import GoodsDetails from "./components/info/ShippingGoodsDetails.vue";
import DerivativeShippings from "./components/attachments/DerivativeShippings.vue";
import SameRegionShippings from "./components/info/SameRegionShippings.vue";
import DatesTable from "./components/DatesTable.vue";
import GoodsSummary from "./components/info/GoodsSummary.vue";
import RelationsMap from "../../components/RelationsMap.vue";
import Attachments from "../../components/attachments/Attachments.vue";
import auth from "../../auth.js";
import userAccess from "./user-access.js";
import ShippingDelivery from "./components/phases/ShippingDelivery.vue";
import * as shippingsApi from "../../backend/shippingsApi.js";
import PrintForm from "./components/PrintForm.vue";
import { eShippingStates } from "./shipping-states.js";
import ImagesList from "../../components/images/ImagesList.vue";
import { attachmentsType } from "../../enums/attachments-types.js";
import CategoriesInfo from "./components/info/CategoriesInfo.vue";
import { routeStates } from "../routes/route-states.js";
import { userRoles } from "../../enums/user-roles.js";

export default {
  components: {
    appInfo: Info,
    appNotes: Notes,
    appMessages: Messages,
    appEditor: Editor,
    VersionSwitcher,
    appStatesHistory: StatesHistory,
    appLables: Lables,
    appShippingOutputForm: ShippingOutputForm,
    appGoodsDetails: GoodsDetails,
    appDerivativeShippings: DerivativeShippings,
    appSameRegionShippings: SameRegionShippings,
    DatesTable,
    GoodsSummary,
    RelationsMap,
    Attachments,
    ShippingDelivery,
    PrintForm,
    ImagesList,
    CategoriesInfo,
  },
  mixins: [userAccess],
  props: ["id"],
  data() {
    return {
      tmpInfoItems: null,
      editorDialog: false,
      editor: false,
      currentVersion: 0,
      tmpShippingDates: null,
      printMode: false,
      activeTab: 0,
      user: null,
      images: [],
      labelsLoading: false,
      labelDialog: false,
      labelDialogDeleteMode: false,
      labelDialogInvoice: false,
      labelDialogEx: false,
      route: null,
      showActionDialog: false,
      readyToLeave: false,
    };
  },
  computed: {
    isHandledByAdmin() {
      return this.$store.getters["shipping/isHandledByAdmin"];
    },
    pageLoaded() {
      return (
        this.$store.getters["shipping/infoLoaded"] &&
        this.$store.getters["shipping/messagesLoaded"] &&
        this.$store.getters["shipping/notesLoaded"] &&
        this.$store.getters["shipping/versionsLoaded"]
      );
    },
    canEdit() {
      return (
        this.currentVersion === 0 &&
        this.state !== this.eShippingStates.NotAccepted &&
        this.state !== this.eShippingStates.CanceledByClient
      );
    },
    states() {
      return this.$store.getters["shipping/shippingStates"];
    },
    notAllowedStates() {
      return this.$store.getters["shipping/notAllowedStates"];
    },
    currentState() {
      return this.states.find((i) => {
        return i.id === this.state;
      });
    },
    blockHeight() {
      if (this.isRoleClient) {
        return window.innerHeight - 45;
      }
      return window.innerHeight - 246;
    },
    blockInfoHeight() {
      return this.blockHeight - 103;
    },
    blockActionsHeight() {
      return this.blockHeight - 184;
    },
    info() {
      if (this.isRoleClient) {
        return this.infoItems
          .filter(
            (i) =>
              i.items &&
              i.items.filter(
                (i) =>
                  Object.prototype.hasOwnProperty.call(i, "roles") &&
                  i.roles.indexOf("client") != -1
              ).length
          )
          .map((m) => {
            return {
              title: m.title,
              event: m.event,
              items: m.items
                ? m.items
                    .filter(
                      (i) =>
                        Object.prototype.hasOwnProperty.call(i, "roles") &&
                        i.roles.indexOf("client") != -1
                    )
                    .map((i) => {
                      return { ...i };
                    })
                : [],
            };
          });
      }
      return this.infoItems;
    },
    infoItems() {
      return this.$store.getters["shipping/infoItems"];
    },
    title() {
      return this.$store.getters["shipping/title"];
    },
    attachments() {
      return this.$store.getters["shipping/attachments"];
    },
    attachmentsForExport() {
      return this.$store.getters["shipping/attachmentsForExport"];
    },
    labels() {
      return this.$store.getters["shipping/labels"];
    },
    dates() {
      return this.$store.getters["shipping/dates"];
    },
    versions() {
      return this.$store.getters["shipping/versions"];
    },
    state() {
      return this.$store.getters["shipping/state"];
    },
    changeStateProccessedByServer() {
      return this.$store.getters["shipping/changeStateProccessedByServer"];
    },
    compactMode() {
      return this.$store.getters["shipping/compactMode"];
    },
    isRoleClient: {
      get() {
        return this.$store.getters["shipping/isClient"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsClient", value);
      },
    },
    isClientManagerRole() {
      const isClientManagerUser = this.user.roles.some(
        (role) => role.id === userRoles.ClientManager
      );

      return isClientManagerUser;
    },
    eShippingStates() {
      return eShippingStates;
    },
    availableStates() {
      let states = [];
      switch (this.state) {
        case eShippingStates.InProcess:
          {
            states = this.states.filter((s) => {
              return (
                s.id !== this.state &&
                (s.id === eShippingStates.NotAccepted ||
                  s.id === eShippingStates.CanceledByClient)
              );
            });
          }
          break;
        case eShippingStates.NotAccepted:
          {
            states = this.states.filter((s) => {
              return s.id !== this.state && s.id === eShippingStates.InProcess;
            });
          }
          break;
        case eShippingStates.CanceledByClient:
          {
            states = this.states.filter((s) => {
              return s.id !== this.state && s.id === eShippingStates.InProcess;
            });
          }
          break;
      }
      return states;
    },
    isSplited() {
      return !!this.$store.getters["shipping/isSplited"];
    },
    notes() {
      return this.$store.getters["shipping/notes"];
    },
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    attachmentsType() {
      return attachmentsType;
    },
    invoiceInSystem() {
      const inSystem = 1;
      return this.labels.find(
        (l) => l.name === "invoice" && l.value === inSystem
      );
    },
    exInSystem() {
      const inSystem = 1;
      return this.labels.find(
        (l) =>
          l.name === "ex" &&
          l.value.find(
            (v) => v.name === "exDocumentInSystem" && v.value === inSystem
          )
      );
    },
    isPhasesInRoute() {
      return !!this.phases.find((p) => p.route);
    },
    unreadMessages() {
      const messages = this.$store.getters["shipping/messages"];
      return messages.filter((m) => !m.isReaded);
    },
    isAllowEditPhase() {
      return (
        auth.isClientManager() &&
        this.$store.getters["shipping/isAllowEditPhase"]
      );
    },
    needSync() {
      return this.$store.getters["releaseOrders/needSync"];
    },
    needConfirmForAttachments() {
      const phase = this.phases.find((p) => p.isLast);
      if (
        phase &&
        phase.route?.state?.id === routeStates.CUSTOMSENTRYREGISTRATION
      ) {
        return {
          need: true,
          text: `Маршрут ${phase?.route?.title} сейчас проходит Затаможку. Подтвердите действие`,
        };
      } else if (
        phase &&
        phase.route?.state?.id > routeStates.CUSTOMSENTRYREGISTRATION
      ) {
        return {
          need: true,
          text: `Маршрут ${phase?.route?.title} уже затаможен. Подтвердите действие`,
        };
      } else {
        return {
          need: false,
          text: "",
        };
      }
    },
  },
  watch: {
    currentVersion(newVersion, prevVersion) {
      if (prevVersion === 0) {
        this.tmpInfoItems = this.infoItems;
        this.tmpShippingDates = {
          readyToLoadDates: {
            ...this.dates.readyToLoadDates,
          },
          deliveryToUnloading: {
            ...this.dates.deliveryToUnloading,
          },
          shipmentFromStoreKiev: {
            ...this.dates.shipmentFromStoreKiev,
          },
        };
      }
      if (this.currentVersion) {
        this.getCurrentVersion(newVersion);
      } else {
        this.$store.commit("shipping/setInfoShipping", this.tmpInfoItems);
        this.tmpInfoItems = null;

        this.$store.commit("shipping/setDates", this.tmpShippingDates);
        this.tmpShippingDates = null;
      }
    },
  },
  async created() {
    const isClient = auth.getUser().isClient;
    this.user = auth.getUser();
    this.$store.commit("shipping/setIsClient", isClient);
    await this.$store.dispatch("shipping/getShipping", this.id);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.needSync || this.readyToLeave) {
      next();
    } else {
      this.route = to;
      this.showActionDialog = true;
      next(false);
    }
  },
  methods: {
    showEditor() {
      this.editorDialog = true;
    },
    closeEditor() {
      this.editorDialog = false;
    },
    async handleShipmentRequestChange() {
      this.editorDialog = false;
      await this.$store.dispatch("shipping/getShipping", this.id);
      await this.$store.dispatch("shipping/getPhases", this.id);
    },
    updateLabel(newValue) {
      let label = {};
      const labelItems = this.labels;
      if (!newValue.groupName) {
        label = labelItems.find((l) => l.name === newValue.name);
      } else {
        label = labelItems
          .find((l) => l.name === newValue.groupName)
          .value.find((l) => l.name === newValue.name);
        labelItems.find((l) => l.name === newValue.groupName).author =
          newValue.author;
        if (newValue.value === 5 || newValue.value === 6) {
          labelItems
            .find((l) => l.name === newValue.groupName)
            .value.find((l) => l.name === "exDocumentInSystem").value = 0;
        }
      }
      if (label) {
        label.value = newValue.value;
        label.author = newValue.author;
      }
      this.$store.commit("shipping/setLabels", labelItems);
    },
    async getCurrentVersion(newVersion) {
      const res = await shippingsApi.getCurrentShippingVersion(
        this.id,
        newVersion
      );
      this.$store.dispatch("shipping/updateInfo", res.Version);
      const dates = {
        readyToLoadDates: {
          request: res.RouteDates.ReadyDate,
          plan: res.RouteDates.ReadyForShipmentPlan,
          fact: res.RouteDates.ReadyForShipmentFact,
        },
        dateOfExportFromFactory: {
          plan: res.RouteDates.DateOfExportFromFactoryPlan,
          fact: res.RouteDates.DateOfExportFromFactoryFact,
        },
        deliveryToUnloading: {
          request: {
            dateFrom: res.RouteDates.WantedDateFrom,
            dateTo: res.RouteDates.WantedDateTo,
          },
          plan: res.RouteDates.DeliveryToUnloadingPlacePlan,
          fact: res.RouteDates.DeliveryToUnloadingPlaceFact,
        },
        shipmentFromStoreKiev: {
          request: "",
          plan: res.RouteDates.ReleaseOrderDates,
          fact: "",
        },
      };
      this.$store.commit("shipping/setDates", dates);
    },
    openPrintForm(value) {
      this.printMode = value;
    },
    changeActiveTab(value) {
      return (this.activeTab = value);
    },
    async changeState(stateId) {
      if (
        this.phases.length > 0 &&
        (stateId === this.eShippingStates.CanceledByClient ||
          stateId === this.eShippingStates.NotAccepted)
      ) {
        return;
      } else {
        await this.$store.dispatch("shipping/changeState", {
          id: this.id,
          state: stateId,
        });
      }
    },
    async restore() {
      await this.$store.dispatch("shipping/restore", { id: this.id });
    },
    resetLoaders() {
      this.$store.commit("shipping/setInfoLoaded", true);
      this.$store.commit("shipping/setMessagesLoaded", true);
      this.$store.commit("shipping/setNotesLoaded", true);
      this.$store.commit("shipping/setVersionsLoaded", true);
    },
    getImages(images) {
      this.images = images;
    },
    openLabelDialog(isDeleted) {
      this.labelDialogDeleteMode = isDeleted ? true : false;
      if (this.labelDialogDeleteMode) {
        if (!this.invoiceInSystem && !this.exInSystem) {
          return;
        }
        this.labelDialogInvoice = this.invoiceInSystem;
        this.labelDialogEx = this.exInSystem;
        this.labelDialog = true;
      } else {
        if (this.invoiceInSystem && this.exInSystem) {
          return;
        }
        this.labelDialog = true;
      }
    },
    async changeLabel() {
      this.labelsLoading = true;
      if (this.labelDialogInvoice || this.labelDialogDeleteMode) {
        await this.changeInvoiceInSystem();
      }
      if (this.labelDialogEx || this.labelDialogDeleteMode) {
        await this.changeExDocumentInSystem();
      }
      this.labelsLoading = false;
      this.labelDialog = false;
    },
    async changeInvoiceInSystem() {
      const invoiceInSystem = this.labelDialogInvoice ? 1 : 2;
      const authorInvoice = await shippingsApi.changeShippingLabel(
        this.id,
        "invoice",
        invoiceInSystem
      );
      this.updateLabel({
        name: "invoice",
        value: invoiceInSystem,
        author: authorInvoice,
      });
    },
    async changeExDocumentInSystem() {
      const exInSystem = this.labelDialogEx ? 1 : 0;
      const authorEx = await shippingsApi.changeShippingLabel(
        this.id,
        "exDocumentInSystem",
        exInSystem
      );
      this.updateLabel({
        name: "exDocumentInSystem",
        value: exInSystem,
        groupName: "ex",
        author: authorEx,
      });
    },
    closeLabelDialog() {
      this.labelDialog = false;
    },
    changeAttachmentsForExport(value) {
      this.$store.commit("shipping/setAttachmentsForExport", value);
    },
    changeAttachments(value) {
      this.$store.commit("shipping/setAttachments", value);
    },
    confirmActionDialog() {
      this.readyToLeave = true;
      this.showActionDialog = false;
      this.$router.push(this.route);
    },
    closeActionDialog() {
      this.showActionDialog = false;
      this.readyToLeave = false;
      this.route = null;
    },
    handleOnChangeExportFileVisibility(updatedFiles) {
      this.changeAttachmentsForExport(updatedFiles);
    },
    async markAsHandled(value) {
      this.$store.commit("shipping/setIsHandledByAdmin", value);
      await shippingsApi.markShippingAsHandled(this.id);
    },
  },
};
</script>

<style>
.btn-back-style {
  height: 25px;
  min-width: 30px;
  padding: 0;
}
.title-style {
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 50px;
}
.v-window__container .v-window__.container--is-active {
  height: 500px;
}
.invisible-block {
  display: none;
}
.handleByAdminCheckbox {
  display: inline-block;
  max-width: 36px;
  margin-right: 8px;
}
.handleByAdminCheckbox .v-input--selection-controls {
  margin: 0;
  padding: 0;
}
.handleByAdminCheckbox
  .v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin: 0;
}
.handleByAdminCheckbox .v-messages {
  display: none;
}
.handleByAdminCheckbox i.v-icon {
  min-width: 24px;
  font-size: 20px;
}
</style>
